// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.companyonboarding.RentalManagerUserManagementOnboardingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

export const RentalManagerUserManagementOnboardingWebApiHandler_declineUserManagementInvitation_Path =
  '/api/web/v1/users/companyOnboarding/declineUserManagementInvitation';

/**
 * Decline invitation to user management
 */
export const RentalManagerUserManagementOnboardingWebApiHandler_declineUserManagementInvitation = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserManagementOnboardingWebApiHandler_declineUserManagementInvitation_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementOnboardingWebApiHandler_onboardPendingUser_Path =
  '/api/web/v1/users/companyOnboarding/onboardPendingUser';

/**
 * Onboard pending user to a company by saving pending permissions
 */
export const RentalManagerUserManagementOnboardingWebApiHandler_onboardPendingUser = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserManagementOnboardingWebApiHandler_onboardPendingUser_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
